export default __webpack_public_path__ + "static/media/chevron-down.64c54965.svg";